import * as React from "react";
import { io } from "socket.io-client";

import ActivateGameModal from "./ActivateGameModal";
import SalesCalendar from "./SalesCalendar";
import SaleDayDetail from "./SaleDayDetail";

interface SalesScreenProps {
  onGoConfirm: () => void;
  onGoSettlement?: () => void;
}

// Sales tab shell. Owns the shared socket connection and swaps between the
// Monthly Report calendar (node 2065:399) and a single day's detail table
// (node 2143:121). The Activate tab opens the shared Activate popup here.
const SalesScreen: React.FC<SalesScreenProps> = ({ onGoConfirm, onGoSettlement }) => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  const currencySymbol = config?.currencySymbol ?? "$";
  const shopId = JSON.parse(localStorage.getItem("UserData") || "{}")?.uId;

  const [subView, setSubView] = React.useState<"calendar" | "day">("calendar");
  const [selectedDate, setSelectedDate] = React.useState<string>("");
  const [activateOpen, setActivateOpen] = React.useState<boolean>(false);
  const [socket, setSocket] = React.useState<any>();

  React.useEffect(() => {
    const established = io(apiBaseURL, { autoConnect: true, query: { userId: shopId } });
    setSocket(established);
    return () => {
      established && established.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDay = (date: string) => {
    setSelectedDate(date);
    setSubView("day");
  };

  const tabHandlers = {
    onConfirmClick: onGoConfirm,
    onActivateClick: () => setActivateOpen(true),
    onSettlementClick: onGoSettlement,
  };

  return (
    <>
      {subView === "calendar" ? (
        <SalesCalendar
          apiBaseURL={apiBaseURL}
          shopId={shopId}
          currencySymbol={currencySymbol}
          onDayClick={openDay}
          {...tabHandlers}
        />
      ) : (
        <SaleDayDetail
          apiBaseURL={apiBaseURL}
          shopId={shopId}
          socket={socket}
          currencySymbol={currencySymbol}
          initialDate={selectedDate}
          onBackToCalendar={() => setSubView("calendar")}
          {...tabHandlers}
        />
      )}

      <ActivateGameModal
        open={activateOpen}
        onClose={() => setActivateOpen(false)}
        socket={socket}
        apiBaseURL={apiBaseURL}
        shopId={shopId}
        onActivated={() => { /* dashboard/TV update over socket; day view refetches on open */ }}
      />
    </>
  );
};

export default SalesScreen;
